import Kanban from './kanban.element.js';

export default Kanban;

Kanban.define('wje-kanban', Kanban);
